
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <circle cx="4" cy="12" r="2"></circle><path opacity="0.5" d="M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 9.99999 13.1046 9.99999 12M14 12C14 10.8954 13.1046 10 12 10C10.8954 10 9.99999 10.8954 9.99999 12M14 12L17.9943 11.9836M9.99999 12H5.99835M17.9943 11.9836C17.9943 13.0882 18.8897 13.9836 19.9943 13.9836C21.0988 13.9836 21.9943 13.0882 21.9943 11.9836C21.9943 10.8791 21.0988 9.98364 19.9943 9.98364C18.8897 9.98364 17.9943 10.8791 17.9943 11.9836Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiHorizontalSteps",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
